import React from "react";

const NoPayments = () => {
  return (
    <div className="jumbotron justify-content-center">
      <h3 className="h3 text-center text-primary"> No Payments</h3>
    </div>
  );
};

export default NoPayments;
